export function getSelection(node) {
    return {
        start: node.selectionStart || 0,
        end: node.selectionEnd || 0
    };
}
export function setSelection(node, start, end) {
    node.setSelectionRange(start, end);
}
//# sourceMappingURL=SelectionUtils.js.map